import { render, staticRenderFns } from "./FacultySummary.vue?vue&type=template&id=21f1354a&"
import script from "./FacultySummary.vue?vue&type=script&lang=js&"
export * from "./FacultySummary.vue?vue&type=script&lang=js&"
import style0 from "./FacultySummary.vue?vue&type=style&index=0&id=21f1354a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports